import { render, staticRenderFns } from "./coupon_edit.vue?vue&type=template&id=2fdc45cb&scoped=true"
import script from "./coupon_edit.vue?vue&type=script&lang=js"
export * from "./coupon_edit.vue?vue&type=script&lang=js"
import style0 from "./coupon_edit.vue?vue&type=style&index=0&id=2fdc45cb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc45cb",
  null
  
)

export default component.exports